import '~/assets/scss/autorefill.scss'

import Accordion from '~/js/modules/accordion';
import getSwiperSlider from '~/js/modules/slider';

window.addEventListener(`DOMContentLoaded`, () => {
    const accordions = document.querySelectorAll(`.accordion`);

    if (accordions.length) {
        accordions.forEach((accordion) => {
            if (!accordion.classList.contains('main-nav__list')) {
                new Accordion(accordion)
            }
        });
    }

    const autorefillCarousel = document.querySelector('.js-autorefill-slider');
    if (autorefillCarousel) {
        const autorefillCarouselParams = {
            slidesPerView: 'auto',
            freeMode: false,
            spaceBetween: 40,
            autoplay: {
                delay: 15000,
                waitForTransition: false,
                disableOnInteraction: false,
            },
            pagination: {
                el: `.slider-dots`,
                clickable: true,
                bulletClass: `slider-dots__dot`,
                bulletActiveClass: `active`,
                renderBullet(index, className) {
                    return `
                    <button class="${className}">
                    </button>`;
                },
            },
        }
        getSwiperSlider(autorefillCarousel, autorefillCarouselParams);
    }

    const productsSlider = document.querySelector(`.products__slider`);
    const productsSliderMobile = document.querySelector(`.products__slider-mobile`);
    let productsSwiper;
    let productsSwiperMobile;

    const productsSwiperParams = {
        slidesPerView: `auto`,
        loop: false,
        autoplay: false,
        pagination: false,
    };

    if (productsSlider) {
        productsSwiper = getSwiperSlider(productsSlider, productsSwiperParams);
    }
    if (productsSliderMobile) {
        productsSwiperMobile = getSwiperSlider(productsSliderMobile, productsSwiperParams);
    }


    const tabLink = document.querySelectorAll(`.js-tabs-link-autorefill`);
    const tabBlock = document.querySelectorAll(`.js-tabs-block-autorefill`);
    let tabnum, scrollInterval;

    tabLink.forEach((tl) => {
        tl.addEventListener("click", event => {
            tabnum = tl.dataset.tab;
            tabBlock.forEach((tb) => {
                if(tb.dataset.tab == tabnum) {
                    let longImage = tb.querySelector('.bank-screen')
                    if(scrollInterval) {
                        window.clearInterval(scrollInterval)
                    }
                    scrollInterval = setInterval(function(){
                        if(longImage.scrollTop == 0) {
                            longImage.scrollBy({
                                top: longImage.scrollHeight,
                                left: 0,
                                behavior: 'smooth'
                            });
                        }
                        else {
                            longImage.scrollBy({
                                top: -longImage.scrollHeight,
                                left: 0,
                                behavior: 'smooth'
                            });
                        }
                    }, 4000);
                }
            });
        });
    });
});
